document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-product-review-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const reviews = document.getElementById('judgeme_product_reviews');
  if (!reviews) return;

  event.preventDefault();
  reviews.setAttribute('tabindex', '-1');
  reviews.focus({ preventScroll: true });
  reviews.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'start'
  });
});
